<template>
    <div class="position-relative">
        <div v-if="isLoading" class="card-info-root">
            <i class="el-icon-loading"></i> 
            Carregando anexos...
        </div>

        <div v-else-if="attachmentsTypes.length > 0">
            <Tabs>
                <TabPane
                    v-for="(attachmentType) in attachmentsTypes"
                    :key="attachmentType.id" 
                >
                    <span slot="label" class="position-relative">
                        <span class="ml-1">{{attachmentType.descricao}}</span>
                        <span v-if="countAttachmentsByType(attachmentType.id) > 0" class="card-chip">
                            {{ countAttachmentsByType(attachmentType.id) }}
                        </span>
                    </span>
                    <Attachment 
                        :key="attachmentType.id" 
                        :tipo-anexo="attachmentType"
                        :anexos="payload.anexos"
                        @removeAnexo="removeAttachment"
                    />
                </TabPane>
            </Tabs>
        </div>

        <Empty v-else description="Nenhum anexo disponível"></Empty>

        <div 
            v-if="this.$store.getters['user/isAnyRole'](['adm', 'cadastro', 'financeiro'])"
            class="d-flex justify-content-end"
        >
           <Button 
                v-if="!isLoading" 
                type="primary" 
                plain
                @click="onSubmit()"
                :disabled="isSubmiting"
            >
                Salvar Anexos
                <i v-if="!isSubmiting" class="el-icon-right"></i> 
                <i v-else class="el-icon-loading"></i> 
           </Button>
        </div>
    </div>
</template>
<script>
    import { watch,onMounted } from "vue";

    // Components
    import { Tabs, TabPane, Button, Loading, Message, Notification, Empty } from "element-ui"
    import { Form, FormItem, Input } from "element-ui"

    import Attachment from "../../util/anexo.vue"

    // Api
    import { ProspectoAnexosApi } from "@/api/Prospecto/ProspectoAnexoApi.js";
    const prospectoAnexosApi = new ProspectoAnexosApi();

    export default {
        layout: "DashboardLayout",
        props: {
            prospect: {
                type: [Object, null],
                default: () => null,
                required: true
            }
        },
        data() {
            return {
                attachmentsTypes: [],
                payload: {
                    anexos: []
                },
                isLoading: false,
                isSubmiting: false,
                dialogCreateTypeAttachmentVisible: false,
                deletedAttachments: null
            }
        },
        async fetch() {
          
        },
        methods: {
            async fetch() {
                this.isLoading = true 

                try {
                    const res = await prospectoAnexosApi.index()
                    this.attachmentsTypes = res

                    if (this.prospect) {
                        this.createAttachments();
                    }
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter os anexos. Algo inesperado ocorreu!'
                    })
                } finally {
                    this.isLoading = false
                }
            },
            async onSubmit() {
                try {
                    const data = this.mountAttachementsFormData(this.payload.anexos)
                    data.append("prospecto_id", this.prospect.id);
                    data.append("delete", this.deletedAttachments ?? "");

                    this.isSubmiting = true

                    const response = await axios({
                        method: 'post',
                        url: "/adm/prospecto_anexo",
                        data
                    })

                    Notification.success({
                        title: 'Sucesso',
                        message: 'Anexo(s) Salvo(s) com Sucesso!'
                    })
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível salvar o(s) anexo(s). Algo inesperado ocorreu!'
                    })
                } finally {
                   this.isSubmiting = false
                }
            },
            // Remove um anexo
            removeAttachment(value) {
                this.deletedAttachments = this.deletedAttachments 
                    ? this.deletedAttachments + ',' + value.toString() 
                    : value.toString()
            },
            // Obter um anexo por ID
            getTypeAttachmentByid(id) {
                return this.attachmentsTypes.find((el) => el.id == id);
            },
            // Associa os anexos do prospeco para ser exibido no componente
            createAttachments() {
                if (this.prospect.anexos == null) {
                    this.loadingAnexos = false;
                    return;
                }

                this.prospect.anexos.forEach((el) => {
                    let config = {
                        path: el.path.replace("public", "storage"),
                        url: '',
                        attachmentType: ''
                    }   

                    config.url =  config.path.length > 0 ? "/" + config.path : ""
                    config.attachmentType = this.getTypeAttachmentByid(el.anexo_para_prospecto_id)

                    let payload = {
                        id: el.id,
                        idTipoAnexo: config.attachmentType.id,
                        descricao: config.attachmentType.descricao,
                        file: null,
                        obrigatorio: config.attachmentType.obrigatorio,
                        tipos_aceitos: config.attachmentType.extensoes,
                        url_arquivo: config.url,
                    }

                    this.payload.anexos.push(Object.assign({}, payload));
                });
            },
            // Quantidade de arquivos selecionados por tipo
            countAttachmentsByType(typeId) {
                return this.payload.anexos.filter(
                    anexo => anexo.idTipoAnexo === typeId
                ).length;
            },
            // Monta a estrutura de envio dos arquivos
            mountAttachementsFormData(anexos) {
                let form = new FormData();

                for (let anexo of anexos) {
                    if (!anexo.id || anexo.id == 0) {
                        form.append(anexo.idTipoAnexo + "_new_files[]", anexo);
                    } else {
                        form.append("anexo[]", anexo.id);
                        form.append('file_' + anexo.id, anexo.file);
                        form.append('file_url_' + anexo.id, anexo.url_arquivo);
                    }
                }
                return form;
            }
        },  
        mounted() {
            this.fetch()
        },
        components: {
            Tabs,
            TabPane, 
            Loading, 
            Message,
            Attachment,
            Button,
            Empty,
            Notification,
        }
    }
</script>
<style>
    .card-chip {
        position: absolute;
        right: -20px;
        top: 50%;
        transform: translateY(-50%);

        display: flex;
        align-items: center;
        justify-content: center;
        width: 16px;
        height: 16px;
        border: 1px solid #dedede;
        border-radius: 9999px;
        font-size: 12px;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/adm_prospecto/partials/Anexos.vue